module.exports = __webpack_public_path__ + "img/dday-popups.0ac07b8d.jpg";